application.register("comp_references_intro", class extends Stimulus.Controller {
    connect() {
        this.selector = this.element;

        this.selector.addEventListener("mouseenter", (e) => this.eventMethode(e) , true);
        this.selector.addEventListener("focusin", (e) => this.eventMethode(e) , true);
    }

    eventMethode(e) {
        console.log(e);
        {
            if (e.target.classList.contains("elm_item")) {

                [...this.selector.querySelectorAll(".elm_item")].forEach((element) => {
                    element.querySelector(".elm_item_text").classList.remove('state--hover')
                });
                e.target.querySelector(".elm_item_text").classList.add("state--hover");
            }
        }
    }
});
